import { inject, Injectable } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { getTranslation } from "../../../utils/i18n.utils";
import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { PromotionTypes } from "../models/promotion-types.model";
import { PromotionTypesApi } from "./promotion-types.api";

@Injectable()
export class PromotionTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<PromotionTypes> {
    private readonly promotionTypesApi = inject(PromotionTypesApi);

    public readonly resource = "promotion-types";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<PromotionTypes> {
        return lastValueFrom(this.promotionTypesApi.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PromotionTypes>> {
        const dto: FindOptionsDto = {
            page,
            pageSize: this.pageSize,
            searchQuery
        };

        return this.promotionTypesApi.search(dto).pipe(
            map((items) => ({
                items,
                nextPage: items.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: PromotionTypes): string {
        if (!isPropertyDefined(item, "name")) {
            return "";
        }

        if (typeof item.name === "string") {
            return item.name;
        }

        return getTranslation(item.name) ?? "";
    }
}
